module.exports = __webpack_public_path__ + "static/media/icon_alert_2x.5e3484ef.png";